import * as React from "react";
// import { pure } from 'recompose';
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import StyledIcon from "@tunnel-components/@sharded/@widgets/icons/component";
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";
import * as i18next from "i18next";
import * as Enums from "@tunnel-enums/index";
import * as Utils from "@Cyclope-Utils/index";

// import BoxGrid from '@tunnel-components/@sharded/widgets/box/custom/component';
// import * as Utils from '@Cyclope-Utils/index';
// import * as Enums from '@tunnel-enums/index';

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    removeCamera,
    onClose,
    isVisible,
    camera,
    suppressioncamerasuccees,
    suppressioncameraerror,
  } = props;

  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();
  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.CAMERADELECTED,
  ]);

  //
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer isVisible={isVisible}>
      <StyledComponent.ModalContainerInsider
        isVisible={isVisible}
        style={{
          overflow: "visible",
          width: "500px",
          backgroundColor: "unset",
        }}
      >
        {isVisible && (
          <div className="boxModalContent">
            <div className="boxModalRemoIcon">
              <StyledIcon deleted={true} color="#007ADF" />
            </div>
            <div className="boxModalContentInsider">
              <p> {i18next.t("etes-vous sur de vouloir supprimer")}</p>
              <p>
                {" "}
                {i18next.t("la camera")}{" "}
                <span style={{ color: "#007ADF", fontWeight: 500 }}>
                  {camera && camera.nameCamera}{" "}
                </span>{" "}
                ?*{" "}
              </p>
              <p>
                *<span>{i18next.t("attention")}</span>
                {i18next.t("cette action est irreversible")}
              </p>
            </div>
            <div className="modalBtn">
              <span
                className="btnSecondary "
                style={{ overflow: "visible", border: "none" }}
                onClick={onClose}
              >
                {i18next.t("annuler")}
              </span>
              {camera && authorization && (
                <span
                  className="btnPrimary "
                  style={{ overflow: "visible" }}
                  onClick={removeCamera(camera.idCamera)}
                >
                  {i18next.t("oui")}
                </span>
              )}
              {camera && !authorization && (
                <span
                  className="btnPrimaryDisabled "
                  style={{ overflow: "visible", padding: "7px 30px" }}
                >
                  {i18next.t("oui")}
                </span>
              )}
            </div>
          </div>
        )}
      </StyledComponent.ModalContainerInsider>
      <SnackBar
        style={{ backgroundColor: "#00E1B3" }}
        isVisible={suppressioncamerasuccees}
        someTextSuccees={`${i18next.t("la suppression de la camera")} ${
          camera && camera.nameCamera
        }  ${i18next.t("a reussie")}`}
      />
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={suppressioncameraerror}
        someTextSuccees={`${i18next.t("la suppression de la camera")} ${
          camera && camera.nameCamera
        }  ${i18next.t("a echouee")}`}
      />{" "}
    </StyledComponent.ModalContainer>
  );
};
/** Valeurs par défaut des props */
Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onClose?: any;
  removeCamera?: any;
  isVisible?: boolean;
  camera?: any;
  suppressioncamerasuccees?: boolean;
  suppressioncameraerror?: boolean;
}
/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/modal/camera/remove/component.tsx